/* eslint-disable */

(function ($) {

  'use strict';

  function isTouchDevice() {
    return 'ontouchstart' in document.documentElement;
  }

  $(window).on('load', function () {
    var $homeHeroSection = $('.paragraph--type-home-hero');

    $homeHeroSection.imagesLoaded( function() {
      $homeHeroSection.addClass('processed');
    });
  });

})(jQuery);

/* eslint-enable */
